export enum EnumTemNFC{
    SEM_NFC,
    TEM_NFC
}